export const getKitName = (kitType: string | null | undefined) => {
  switch (kitType) {
    case 'OHI':
      return 'Oral Health Intelligence';
    case 'HI':
      return 'Health Intelligence';
    case 'GI':
      return 'Gut Intelligence';
    case 'FBI':
      return 'Full Body Intelligence';
    case 'PHPRO':
      return 'Precision Health PRO™';
    case 'CD':
      return 'Cancer Detect'
    case 'OHCDPRO':
      return 'Oral Health & Cancer Detect Pro'
    case 'CDOT':
      return 'Cancer Detect Oral & Throat';
    default:
      return '';
  }
};